<template>
    <bulkintransit-component>
      <b-row class="mt-2 mb-2">          
        <b-col md="4" class="my-1">
          <b-col sm="12" >
          <b-form-group label-cols-sm="3" label="Search" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        </b-col>
  
        <b-col md="4" class="my-1">
          <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
            <b-input-group>
              <b-form-select v-model="sortBy" :options="sortOptions">
                <option slot="first" :value="null">-- none --</option>
              </b-form-select>
              <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                <option :value="false">Asc</option> <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>    
  
        <b-col sm="12" class="text-right">
                 <p > <b>Total Records :<span style="color:red;">{{ this.totalrecords }}</span></b> </p>
                
  
        </b-col>
  
        <b-col id="submit" v-if="this.totalrecords>0"> 
                   <input type='checkbox' @click='checkAll()' v-model='isCheckAll'  > 
                   <span > Select All </span>
                &nbsp;
               &nbsp;&nbsp;&nbsp;
               <b-button v-if="languages.length>0 && isReadOnly==false" type="submit" size="md" variant="primary" @click="allocateshipment" >Allocate</b-button>
               
                 
                 
        </b-col>
  
        <b-col>
          <b-form-group>
            
          </b-form-group>
        </b-col>
      </b-row> 
     
  
      <b-row>
        <b-col md="12">
          <b-col sm="12" >
            <b-table show-empty stacked="md"  :items="items"  :fields="fields"  :current-page="currentPage"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy" >
  
              <template slot="select" slot-scope="row">
                <b-form-group>
                  <input class="shipmentscheckbox" type="checkbox"  v-bind:value="row.item.parentawb"  v-model='languages' @change="multiselectdesign($event,row.item)"/>
                  <!-- <input class="parentAWBcheckbox" type="checkbox"  v-bind:value="row.item.parentawb" @change="multiselectdesign($event,row.item)"  v-model='checkedParentAWB' /> -->
                </b-form-group>
              </template>
  
              <template slot="invoicevalue" slot-scope="row">
                  <span>&#8377; {{row.item.invoicevalue}}</span>
              </template>
              <template slot="awbphysicalweight" slot-scope="row">
                  <span> {{row.item.awbphysicalweight}} {{row.item.unit}}</span>
              </template>
              <template slot="valweight" slot-scope="row">
                  <span> {{row.item.valweight}} {{row.item.unit}}</span>
              </template>
          
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>    
            </b-table> 
          </b-col>
        </b-col>
      </b-row>

      <b-modal v-model="openmodels" hide-footer title="Eway Bill Details" size="lg">
        <div class="d-block text-center">
          <b-table show-empty responsive   :items="ewaybillitem" :busy="isBusyeway"    :current-page="currentPage"  :fields="ewayfields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 
            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div> 
            <template slot="ewaybillpdf" slot-scope="row">
              <div>
               <a :href="row.item.ewaybillpdf" target="_blank"><b-button size="sm"> <i class="fa fa-download" aria-hidden="true"></i>
                Download</b-button></a>
              </div>
            </template>
          </b-table>
        </div>
        <b-button class="mt-3 float-right" variant="danger" @click="hideModal">Close Me</b-button>
      </b-modal>
  
  </bulkintransit-component>
  </template>
  <script>
  import CONSTANTS from '@/utils/constants'
  import Utils from '@/utils'
  import auth from '@/utils/auth'
  export default {
    data: function() {
      return {
        assigned:[],
        items:[],
        isBusy: false,
        fields: [
            {key:'select',label:'Select',},
           { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
            { key: 'invoiceno', label: 'Load ID', sortable: true, sortDirection: 'desc' },
             { key: 'invoicevalue', label: 'Invoice Value', sortable: true,class:'invoicevalue'},
             { key: 'valweight', label: 'Volumetric Weight', sortable: true,class:'valweight'},
            { key: 'awbphysicalweight', label: 'Physical Weight', sortable: true,class:'physicalweight'},
            
           { key: 'mpscount', label: 'MPS Count', sortable: true},
            { key: 'sourceaddress', label: 'Source Address', sortable: true},
            { key: 'destinationaddress', label: 'Destination Address', sortable: true},
            
            { key: 'deliverystatus', label: 'Delivery Status', sortable: true },
            
        ],
        outlined: true,
        totalRows: 0,
        totalrecords:0,
        currentPage: 1,
        //perPage:  10,
        //pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        isCheckAll: false,
        sortDirection: 'asc',
         languages: [],
         toggleInfo: false,
     
          selectedlang: "",
        filter: null,
        openmodels : false,
      ewaybillitem :[],
      ewayfields : [
          {key:'parentawb', label : 'Parent AWB'},
          {key:'ebn', label : 'EBN'},
          {key:'invoiceno', label : 'Invoice No'},
          {key:'ewaybillpdf', label : 'Eway Bill PDF'}
        ],
      isBusyeway : false,
      accessBody:[],
      isReadOnly:false,
      }
    },
    computed: {
        sortOptions() {
          // Create an options list from our fields
          return this.fields
            .filter(f => f.sortable)
            .map(f => {
              return { text: f.label, value: f.key }
            })
        }
    },
    created: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      this.accessBody = userInfo.body;
      console.log("--------->>>>>>>>>>",userInfo.body)
      this.ischeckbodyvalidation();
      this.getAssignedShipment()
    },

  
    methods: {
      ischeckbodyvalidation(){
      for (let i = 0; i < this.accessBody.length; i++) {
        const element = this.accessBody[i];
     
        // if (element.title=='Bulk Reallocation' && element.isReadonly==true && this.route_id=='normal') {
        //   this.isReadOnly=true
        // }
       if (element.child) {
        for (let j = 0; j < element.child.length; j++) {
          const k = element.child[j];
           if (k.title=='Bulk Reallocation' && k.isReadonly==true) {
            this.isReadOnly=true
          }
        }
       }
      }
      console.log(" this.isReadOnly", this.isReadOnly)
    },
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length
          this.currentPage = 1
        },
  
        checkAll: function(){
          this.isCheckAll = !this.isCheckAll;
          this.languages = [];
          // console.log(this.items[0].shippingid);
          if(this.isCheckAll){ // Check all
            for (var key in this.items) {
              this.languages.push(this.items[key].parentawb);
              console.log("this.languages",this.languages);
            }
            
          }
    
          // console.log(this.languages);
    
        },
          
        multiselectdesign(e,value){
        
        if (this.languages.length >=0)

        {
          if (e.target.checked==true){
            if(this.languages.length == this.items.length){
            // console.log("check",this.languages)
            this.isCheckAll = true;
            }
            
          }else{
            if(this.languages.length == 0){
          
            this.isCheckAll = false;
            }  
          }

        }
        },

        updateCheckall: function(){
          alert("oo")
          if(this.languages.length == this.items.length){
            // alert("ifff");
            this.isCheckAll = true;
          }else{
            // alert("else");
            this.isCheckAll = false;
          }
        },
        
        closemodal: function () {
          // console.log('closemodal')
          this.toggleInfo = !this.toggleInfo
        }, 
      
        clear(){ 
  
          this.isBusy = true;
  
          let userData = localStorage.getItem('userData');
          // console.log(userData);
            var vehicleid= document.getElementById('vechicle_from').value; 
          let vehicleidto = document.getElementById('vehicle_to').value; 
            
        
          let userInfo = JSON.parse(userData);
          //let pincode=JSON.stringify(userInfo.pickuplocationpincode);
          let obj = {
            // sysusermasterid:`${userInfo.sysusermasterid}`,
            //   usertype:`${userInfo.user_type}`,
            vehicleid: vehicleid,
            shipmentstatus: "INTransit"
  
          }
            this.$http
              .post(
                `${CONSTANTS.API_URL}/getShipmentStatusListVehicleWise`,obj)
              .then(result => {
                this.isBusy = false;
                  if(result.body.returnmsg === "Successful"){
                    this.assigned = result.body.returnvalue;
                    this.items  = result.body.returnvalue;
                    this.totalrecords = result.body.returnvalue.length;
  
                
                  }else {
                    this.items  = [];
                    this.totalrecords = 0
                    this.isCheckAll = false;
                  
        
                  }
              })
              .catch(ex => {
                console.log('error', ex)
              })
        },
  
        allocateshipment: function(){
          //this.toggleInfo = !this.toggleInfo
  
  
  
          var vehicleidto= document.getElementById('vehicle_to').value;
          // console.log("vehicleidto",vehicleidto)
  
          if(vehicleidto==""  || vehicleidto=="undefined" || vehicleidto==undefined)
          {
  
          // Utils.notify('Please select Delivery Agent to assign Shipment.','error');
            this.$fire({
                        text: "Please Select Vehicle To assign Parent AWB",
                        type: "warning",
                        timer: 30000
                      });
          return false;
          }
          else
          {
  
  
  
          //this.toggleInfo = !this.toggleInfo
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
  
            // console.log("DAT:"+userInfo);
  
            // var mobilenumber=userInfo.usermobilenumber;
            var selectAwb = document.getElementsByClassName('shipmentscheckbox');
  
            var shippingIds=[];
            var rto={};
          // console.log("length:"+selectShipment.length);
              if(selectAwb.length>0)
              {
                for (var i = 0; i < selectAwb.length; i++) {
                    if (selectAwb[i].checked == true){
                      shippingIds.push(selectAwb[i].value)
                      console.log("Sllll",shippingIds);
                    }
                }
              }
  
            if(shippingIds.length >0 )
            {
  
              var rConfirm = confirm("Are you sure to Reallocate Parent AWB ?");
              if (rConfirm == true) 
              {        
  
                var submit = document.getElementById("submit");
                submit.style.display = "block";
              
                rto.parentawb=shippingIds;
                rto.shipmentstatus='INTransit';
                rto.lastmodifiedby=userInfo.sysemailid; 
  
                // rto.mobilenumber=mobilenumber;
              
                rto.vehicleid=vehicleidto;
                console.log("HHHHHHH",rto);
                // return false;
              
                this.$http.post(`${CONSTANTS.API_URL}/consignmentMasterBulkReallocateAwb`,rto )
                  .then((result) => {
                    // console.log(result.body.returnvalue);
                  
                    if (result.body.returnmsg=== 'Successful') {
                      
                    // Utils.notify('Shipment Alloacted successfully');
                      this.$fire({
                        text: "Parent Awb Alloacted Successfully",
                        type: "success",
                        timer: 30000
                      });
                      this.parentEwaybill();
                    this.clear();
                    
                    } 
                    else
  
                    {
                      // Utils.notify('Allocation Limit reached for the agent','error');
                        this.$fire({
                        text: "Allocation Limit reached for the Vehicle",
                        type: "error",
                        timer: 30000
                      });
                    }
  
                    
                  })
  
                  .catch((ex) => {
                    console.log('error-----', ex)
                    
                  })
  
              }    
            }
              
                else
                {
  
                  this.$fire({
                        text: "Please Select atlest 1 Shipment",
                        type: "warning",
                        timer: 30000
                      });
                  // Utils.notify('please select atlest 1 shipment','error');
                }
            
            } 
  
  
        },

        hideModal : function(){
          this.openmodels = false;
        },

        parentEwaybill : function () {
          this.openmodels=true;
          this.isBusyeway=true;
          var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            var selectAwb = document.getElementsByClassName('shipmentscheckbox');
  
          var shippingIds=[];
            if(selectAwb.length>0)
            {
              for (var i = 0; i < selectAwb.length; i++) {
                  if (selectAwb[i].checked == true){
                    shippingIds.push(selectAwb[i].value)
                    console.log("sdsfdsg",shippingIds);
                  }
              }
            }
            const Obj={
              parentawb: shippingIds,
            }
            console.log("obj",Obj)
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getEwaybillListAndDownload`,Obj).then((result)=>{
                console.log("Result",result);
                this.isBusyeway=false;
                if (result.body.returnmsg === 'Successful') {
                  this.ewaybillitem=result.body.returnvalue;
                  console.log("ewaybillitem",this.ewaybillitem)
                }else{
                  this.ewaybillitem=[];
                }
            })
        },
  
        getAssignedShipment(){
  
          let userData = localStorage.getItem('userData');
          
          let vehicleid = document.getElementById('vechicle_from').value; 
  
          // localStorage.getItem('vehicleid');
        
          let userInfo = JSON.parse(userData);
          //let pincode=JSON.stringify(userInfo.pickuplocationpincode);
        //  alert(deliveryagentmasterid);
          if(vehicleid=="" || vehicleid==undefined)
          {
            // alert("In");
              return false;
          }
          else{
            this.isBusy = true;
  
            let obj = {
              // sysusermasterid:`${userInfo.sysusermasterid}`,
              // usertype:`${userInfo.user_type}`,
              vehicleid: vehicleid,
              shipmentstatus: "INTransit"
              }
              console.log("KKKKKK",obj);
              // return false;
              this.$http
                .post(
                  `${CONSTANTS.API_URL}/getShipmentStatusListVehicleWise`,obj)
                .then(result => {
                  console.log("Result",result);
                  this.isBusy = false;
                    if(result.body.returnmsg === "Successful"){
                      // alert("innn");
                      this.assigned = result.body.returnvalue;
                      this.items  = result.body.returnvalue;
                      this.totalrecords = result.body.returnvalue.length
                    }else {
                      this.items  = [];
                      this.totalrecords = 0;
                      var submit = document.getElementById("submit");
                        submit.style.display = "none";
                        
                    }
                })
                .catch(ex => {
                  console.log('error', ex)
                })
            }    
  
  
        },
    }
  
  };
  </script>
  